import { Box, Button, CircularProgress, TextField, Typography, IconButton, InputAdornment } from '@material-ui/core'
import { CheckCircle } from '@material-ui/icons'
import { LoadingButton } from '@material-ui/lab'
import { useEffect, useState, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { submitPasswordReset } from '../../../actions/userActions'
import useExternalScript from '../../../hooks/useExternalScript'
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

// Helper function to calculate discount amount
const calcDiscount = (price, promo) => {
    if (!promo) return 0
    if (promo.coupon.percent_off) return price * (promo.coupon.percent_off / 100)
    return promo.coupon.amount_off
}

const CompleteSignup = () => {
    const location = useLocation();
    const navigate = useNavigate();
    useExternalScript('https://www.dwin1.com/81255.js', 'head');
    // Prevent users from accessing this page directly
    if (!location.state) {
        navigate('/yogarenew/subscriptions')
    }
    const { price, promo, user, token, loggedIn, invoiceId } = location.state
    const [submitError, setSubmitError] = useState('')
    const [submitting, setSubmitting] = useState(false)
    const [step, setStep] = useState(3)
    const [showPassword, setShowPassword] = useState(false);

    const paswordRef = useRef(null)
    const confirmPasswordRef = useRef(null)

    const handlePasswordSetSubmit = async (e) => {
        setSubmitting(true)
        e.preventDefault()
        setSubmitError('')

        const password = paswordRef.current.value
        const confirmPassword = confirmPasswordRef.current.value

        if (password.length < 8) {
            setSubmitError('Password must be at least 8 characters')
            setSubmitting(false)
            return
        }

        if (password !== confirmPassword) {
            setSubmitError('Passwords do not match')
            setSubmitting(false)
            return
        }

        try {
            const result = await submitPasswordReset({ code: token, password, passwordConfirmation: confirmPassword })
            window.localStorage.setItem('accessToken', result.jwt)
            setStep(2)
        } catch (error) {
            setSubmitError(error.message)
        }

        setSubmitting(false)
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    console.log("Value", price.trial_period_days ? 0 : ((price.unit_amount - (promo ? calcDiscount(price.unit_amount, promo) : 0)) / 100))

    useEffect(() => {
        try {
            console.log('CompleteSignup Data:', {
                price,
                user,
                promo,
                location: location.state,
                value: price.trial_period_days ? 0 : ((price.unit_amount - (promo ? calcDiscount(price.unit_amount, promo) : 0)) / 100),
                trial_period_days: price.trial_period_days || null,
                currency: price.currency,
                transaction_id: invoiceId
            });

            window.dataLayer.push({
                event: 'purchase',
                price: price.nickname,
                customer: {
                    customer_email: user.email,
                    user_id: user.id,
                },
                promo: promo,
                ecommerce: {
                    transaction_id: invoiceId,
                    currency: price.currency ? price.currency.toUpperCase() : 'USD',
                    value: price.trial_period_days ? 0 : ((price.unit_amount - (promo ? calcDiscount(price.unit_amount, promo) : 0)) / 100),
                    coupon: promo ? promo.coupon.name : undefined,
                    items: [
                        {
                            item_id: price.id,
                            item_name: price.nickname,
                            item_category: 'subscription',
                            quantity: 1,
                            price: price.unit_amount / 100,
                            discount: promo ? calcDiscount(price.unit_amount, promo) / 100 : 0,
                        }
                    ]
                },
                free_trial: price.trial_period_days ? 'TRUE' : 'FALSE',
                trial_period_days: price.trial_period_days || null,
                items: [
                    {
                        id: price.id,
                        name: price.nickname,
                        category: 'subscription',
                        quantity: 1,
                        price: price.unit_amount / 100,
                        trial_period_days: price.trial_period_days || null,
                        coupon: promo,
                    },
                ],
            });
        } catch (error) {
            console.log("Error sending analytics", error)
        }

        if (loggedIn) {
            setStep(2)
            return
        }

        // If a reset token is provided, set the step to 1
        if (token) {
            setStep(1)
            return
        }

        setStep(-1)
    }, [])

    switch (step) {
        case 0:
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: '5%' }}>
                    <CircularProgress />
                </Box>
            )
        case 1:
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: '5%' }}>
                    <Box sx={{ width: '100%', maxWidth: '500px' }}>
                        <Typography variant="h4" fontWeight={700} sx={{ mb: '2rem', textAlign: 'center' }}>
                            Set a Password
                        </Typography>
                        <Typography variant='subtitle2' textAlign={'center'}>
                            Before we can complete your subscription, you need to set a password for your account.
                        </Typography>
                        <form onSubmit={handlePasswordSetSubmit}>
                            <Box>
                                <Typography variant="body1" fontWeight={"bold"} sx={{ mb: 1 }}>
                                    Password
                                </Typography>
                                <TextField
                                    type={showPassword ? 'text' : 'password'}
                                    inputRef={paswordRef}
                                    sx={{ mb: '1rem' }}
                                    size="small"
                                    fullWidth
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Box>
                            <Box>
                                <Typography variant="body1" fontWeight={"bold"} sx={{ mb: 1 }}>
                                    Confirm Password
                                </Typography>
                                <TextField
                                    type={showPassword ? 'text' : 'password'}
                                    inputRef={confirmPasswordRef}
                                    sx={{ mb: '1rem' }}
                                    size="small"
                                    fullWidth
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Box>
                            <LoadingButton
                                type="submit"
                                variant="contained"
                                sx={{ mb: '1rem', float: 'right', mt: '0.5rem' }}
                                disabled={submitting}
                                loading={submitting}
                            >
                                CONTINUE
                            </LoadingButton>
                            {submitError && (
                                <Typography color="error" sx={{ mb: '1rem' }}>
                                    {submitError}
                                </Typography>
                            )}
                        </form>
                    </Box>
                </Box>
            )
        case 2:
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: '10vh' }}>
                    <Box>
                        <CheckCircle sx={{ position: 'absolute', color: 'green', fontSize: 36 }} />
                        <Typography variant="h4" fontWeight={700} sx={{ mb: '2rem', textAlign: 'center' }}>
                            You're all set!
                        </Typography>
                        <Typography variant="body1" fontWeight={"bold"} sx={{ mb: 1 }}>
                            You can now access all of our content.
                        </Typography>
                        <Box sx={{ width: "100%", textAlign: 'center' }}>
                            <Button variant="contained" href='/yogarenew' sx={{ alignContent: 'center' }}>
                                Go to Yoga Renew
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )
        default:
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: '5%' }}>
                    <Typography color="error" sx={{ mb: '1rem' }}>
                        {submitError}
                    </Typography>
                    <Button variant="contained" href='/yogarenew/subscriptions'>
                        Try Again
                    </Button>
                </Box>
            )
    }
}

export default CompleteSignup